const DiscountMedal = ({ width = 16, height = 16, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g>
        <g>
          <path
            d="M4.27575 8.82715L1.79297 14.8961L3.724 14.3444L4.55159 15.9996L7.03434 10.2065L4.27575 8.82715Z"
            fill="#DE4C3C"
          />
          <path
            d="M10.3445 8.55176L7.58594 10.2069L10.0687 16L10.8963 14.3449L12.8273 14.8966L10.3445 8.55176Z"
            fill="#DE4C3C"
          />
        </g>
        <g>
          <path
            d="M4.27641 8.82715L3.36328 11.0589L3.41019 11.0726L4.00053 12.9044L5.88191 12.5016L6.00328 12.612L7.035 10.2065L4.27641 8.82715Z"
            fill="#C74436"
          />
          <path
            d="M7.58594 10.2069L8.61766 12.6124L8.73903 12.5021L10.6204 12.9049L11.2107 11.0731L11.3183 11.04L10.3445 8.55176L7.58594 10.2069Z"
            fill="#C74436"
          />
        </g>
        <g>
          <path
            d="M7.31014 0L8.73911 1.29103L10.6205 0.885531L11.2108 2.72L13.0425 3.31034L12.6398 5.19172L13.9308 6.62069L12.6398 8.04966L13.0425 9.93103L11.2108 10.5214L10.6205 12.3531L8.73911 11.9503L7.31014 13.2414L5.88117 11.9503L3.9998 12.3531L3.40945 10.5214L1.57498 9.93103L1.98048 8.04966L0.689453 6.62069L1.98048 5.19172L1.57498 3.31034L3.40945 2.72L3.9998 0.885531L5.88117 1.29103L7.31014 0Z"
            fill="#FDB62F"
          />
          <path
            d="M14.207 2.20688C14.1132 1.64081 13.6696 1.19722 13.1035 1.10344C13.6696 1.00966 14.1132 0.566063 14.207 0C14.3007 0.566063 14.7443 1.00966 15.3104 1.10344C14.7443 1.19722 14.3007 1.64078 14.207 2.20688Z"
            fill="#FDB62F"
          />
        </g>
        <path
          d="M13.9318 6.62064L12.6408 5.19167L13.0435 3.3103L11.6174 2.84961C10.0698 7.1227 6.39255 9.53927 3.50977 10.8275L4.0008 12.353L5.88217 11.9503L7.31114 13.2413L8.74011 11.9503L10.6215 12.353L11.2118 10.5213L13.0435 9.93098L12.6408 8.04961L13.9318 6.62064Z"
          fill="#FFA83D"
        />
        <g>
          <path
            d="M5.65422 6.06918C5.04484 6.06918 4.55078 5.57512 4.55078 4.96574C4.55078 4.35637 5.04484 3.8623 5.65422 3.8623C6.26359 3.8623 6.75766 4.35637 6.75766 4.96574C6.75766 5.57512 6.26359 6.06918 5.65422 6.06918ZM5.65422 4.41399C5.34941 4.41399 5.1025 4.6609 5.1025 4.96571C5.1025 5.27052 5.34941 5.51743 5.65422 5.51743C5.95903 5.51743 6.20594 5.27052 6.20594 4.96571C6.20594 4.6609 5.95903 4.41399 5.65422 4.41399Z"
            fill="white"
          />
          <path
            d="M9.24016 9.65512C8.63078 9.65512 8.13672 9.16106 8.13672 8.55168C8.13672 7.94231 8.63078 7.44824 9.24016 7.44824C9.84953 7.44824 10.3436 7.94231 10.3436 8.55168C10.3436 9.16102 9.84953 9.65512 9.24016 9.65512ZM9.24016 7.99993C8.93534 7.99993 8.68844 8.24684 8.68844 8.55165C8.68844 8.85646 8.93534 9.10337 9.24016 9.10337C9.54497 9.10337 9.79187 8.85646 9.79187 8.55165C9.79187 8.24684 9.545 7.99993 9.24016 7.99993Z"
            fill="white"
          />
          <path
            d="M5.57139 8.74794L9.43359 4.88574L9.04347 4.49562L5.18127 8.35782L5.57139 8.74794Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  )
}

export default DiscountMedal
